import {ObjectId, ObjectType} from './object.model';
import {UserId} from './user';
import {Option} from './option';

export const LORAWAN_GATEWAY_INACTIVE = 'lorawan-gateway-inactive';

export interface LorawanGatewayEventInfo {
  Category: typeof LORAWAN_GATEWAY_INACTIVE;
  LoRaWAN?: {
    GatewayEUI: string;
  };
}

export interface AlarmEvent {
  UUID: string;
  ObjectID: ObjectId;
  ObjectType: ObjectType;
  StartTime: string;
  AckTime: string;
  ClearTime: string;
  SyncTime: string;
  AckUser: UserId;
  ClearUser: UserId;
  EventInfo: any;
  IdempotencyKey?: string;
}

interface QueryResult {
  Count: number;
  Pages: number;
}

export interface EventQuery {
  UUID?: string;
  App?: string;
  User?: string;
  ActiveOnly?: string;
  CountOnly?: string;
  NoCount?: string;
  ObjectID?: string;
  ObjectType?: string;
  Page?: string;
  Qty?: string;
}

export interface EventQueryResult extends QueryResult {
  Query: EventQuery;
  ResultSet: AlarmEvent[];
}

export interface AlarmValue {
  UUID: string;
  EventUUID: string;
  Data: {
    Value?: string | number | boolean | null;
    ReadErrors?: number;
    WriteErrors?: number;
    ErrorMessage?: string;
  };
  Time: string;
  SyncTime: string;
}

export interface ValueQuery {
  EventUUID: string;
  Page?: string;
  Qty?: string;
  NoCount?: string;
}

export interface ValueQueryResult extends QueryResult {
  Query: ValueQuery;
  ResultSet: AlarmValue[];
}

export type AlarmStage = 'unacked' | 'acked' | 'cleared';

export type AutoClearSetting = '' | 'acked' | 'all';

export const AUTO_CLEAR_ALL: AutoClearSetting = 'all';

export const AutoClearOptions: Readonly<Readonly<Option>[]> = [
  {
    id: '',
    name: 'Never',
  },
  {
    id: 'acked',
    name: 'Only if acknowledged',
  },
  {
    id: 'all',
    name: 'Always',
  },
];
